module.exports = __webpack_public_path__ + "img/card_informe_asistencia.4ce1ae40.svg";